export default "__VITE_ASSET__DNUncD0T__"